export default "Kan fisken fange alle de livlige tanglopper? Sæt gang i kroppen med denne sjove fangeleg!";